<style scoped>
    .empty-wrap {
        height: 500px;
    }
</style>
<template>
    <div class="main-list" v-if="!loadingCheck">
        <TournamentContent v-for="tournament in tournamentList" :key="tournament.tnmtId"
                           :tournament="tournament"></TournamentContent>
        <EmptyContent v-if="tournamentList.length <=0" content="검색결과가 없습니다"></EmptyContent>
    </div>
    <Spinner v-else></Spinner>
</template>
<script>
    import {mapState} from 'vuex'
    import TournamentContent from "../tournament/TournamentContent";
    import EmptyContent from "../common/EmptyContent";

    export default {
        components: {EmptyContent, TournamentContent},
        computed: {
            ...mapState('searches', ['tournaments'])
        },
        data() {
            return {
                tournamentList: [],
                hasMore: false,
                infiniteId: +new Date(),
                page: 1,

                loadingCheck: false
            }
        },
        created() {
            this.loadingCheck = true
            const _this = this

            this.$store.dispatch('searches/tournamentSearch', {
                sportType: this.$route.query.sportType,
                searchTerm: this.$route.query.searchTerm
            }).then(res => {
                _this.tournamentList = res.tournamentList

                _this.hasMore = res.tournamentList.length > 0
                _this.loadingCheck = false
            }).catch(err => {
                console.dir('searches/tournmanetSearch err => ')
                console.dir(err)
                _this.loadingCheck = false

            })


        },
    }
</script>
